<div class="container" *ngIf="importRequest" (click)="navigateToDetail(importRequest.adsCode)">

    <div class="container-img">
      <figure class="figure-img">
        <img class="image" *ngIf="importRequest.pictures.length>0" [src]="getImageUrl(importRequest)" />
      </figure>
    </div>
    <div class="container-info">
    <section class="section-info-top">
        <section class="section-text">
          <span class="label">{{'ProductsCardInfo.harvest' | translate}}:</span>
          <!-- <span class="text-small">{{formatDate(importRequest.harvestDate)}}</span> -->
        </section>
        <section class="section-text">
          <span class="text-small">{{importRequest.netKilos}}</span>
          <span class="label">{{'ProductsCardInfo.netKilos' | translate}}</span>
        </section>
        <section class="section-text">
          <span class="text-small">{{importRequest.caseQuantityPerPallet}}</span>
          <span class="label">{{'ProductsCardInfo.casesPerPallet' | translate}}</span>
        </section>
      </section>
      <section class="section-name">
        <h3 class="title" *ngIf="importRequest.variety">{{importRequest.variety.species | speciesName}}</h3>
        <section class="section-text">
          <span class="label">{{'ProductsCardInfo.variety' | translate}}:</span>
          <span class="text-small" *ngIf="importRequest.variety">{{importRequest.variety.name}}</span>
        </section>
      </section>
      <section class="section-data">
        <section class="section-data-left">
          <section class="section-text">
            <span class="label">{{'ProductsCardInfo.speciesSize' | translate}}:</span>
            <span class="text-small">{{importRequest.speciesSize}}</span>
          </section>
          <section class="section-text">
            <span class="label">{{'ProductsCardInfo.category' | translate}}:</span>
            <span class="text-small">{{importRequest.category}}</span>
          </section>
        </section>
        <section class="section-data-right">
          <section class="section-text-center">
            <span class="text-price"><small>$</small> {{(importRequest.pricePerCase).toFixed(2)}}</span>
            <span class="label-price">/ {{importRequest.typeSale}} USD</span>
          </section>
          <section class="section-text">
            <span class="label">{{'ProductsCardInfo.available' | translate}}:</span>
            <span class="text-small">{{importRequest.palletQuantity}} pallets</span>
          </section>
        </section>
      </section>
    </div>
  </div>
